import React from 'react';
import { useNavigate } from 'react-router-dom';

type TextProps = {
  text?: string;
  fontSize?: string;
  fontWeight?: number | string;
  lineHeight?: string;
  color?: string;
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  style?: React.CSSProperties;
  navigateToHome?: boolean;
};

const Text: React.FC<TextProps> = ({
  text = 'ChatAssistant',
  fontSize = '32px',
  fontWeight = 700,
  lineHeight = '38px',
  color = '#030303',
  textAlign = 'right',
  style = {},
  navigateToHome = false,
}) => {
  const navigate = useNavigate();

  const combinedStyles: React.CSSProperties = {
    fontFamily: 'Montserrat',
    fontSize,
    fontWeight,
    lineHeight,
    color,
    textAlign,
    ...style,
  };

  const content = <div style={combinedStyles}>{text}</div>;

  return navigateToHome ? (
    <div onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
      {content}
    </div>
  ) : (
    content
  );
};

export default Text;
